import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Circle = createReactComponent("Circle", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}]]]);
export default Circle;